import axios from "axios"; // 引入axios

axios.defaults.baseURL = "http://eport.bt-market.yndth.cn";

const serve = axios.create({
  timeout: 10000,
  responseType: "json"
});

// 发送请求前 拦截处理
serve.interceptors.request.use(config => {
  return config;
});

// 请求响应时 拦截处理
serve.interceptors.response.use(
  res => {
    let { data } = res;
    //处理除code等于200外的异常 目前的接口无法通过http status code 来判断后台异常
    if (data.code === "200") {
      return Promise.resolve(data);
    } else {
      return Promise.reject(data);
    }
  },
  error => {
    let msg = handlerResponseErrorStatus(error);
    return Promise.reject(msg);
  }
);

/**
 * 处理请求响应状态码
 * @param {*} error 错误消息
 */
const handlerResponseErrorStatus = status => {
  let errorMsg = {};
  switch (status) {
    case 400:
      errorMsg.msg = "请求错误,参数不匹配";
      errorMsg.code = 400;
      break;

    case 401:
      errorMsg.msg = "未授权，请登录";
      errorMsg.code = 400;
      break;

    case 403:
      errorMsg.msg = "拒绝访问";
      errorMsg.code = 403;
      break;

    case 404:
      errorMsg.msg = `请求地址找不到: `;
      errorMsg.code = 404;
      break;

    case 408:
      errorMsg.msg = "请求超时";
      errorMsg.code = 408;
      break;

    case 500:
      errorMsg.msg = "请求出错,服务器内部错误";
      errorMsg.code = 500;
      break;

    case 501:
      errorMsg.msg = "服务未实现";
      errorMsg.code = 501;
      break;

    case 502:
      errorMsg.msg = "网关错误";
      errorMsg.code = 402;
      break;

    case 503:
      errorMsg.msg = "服务不可用";
      errorMsg.code = 503;
      break;

    case 504:
      errorMsg.msg = "网关超时";
      errorMsg.code = 504;
      break;

    case 505:
      errorMsg.msg = "HTTP版本不受支持";
      errorMsg.code = 505;
      break;
    default:
      errorMsg.msg = "未知错误";
      errorMsg.code = 9999;
  }

  return errorMsg;
};

export default serve;
